export const appID = "aV7bjOHpAYFLEOrJ3aMHnj55r0Q7ix7I4omsalgH";
export const serverURL = "https://api.ihomeworkapp.com/parse";


// WEBPACK FOOTER //
// ./src/config/parse.js